import axios from "axios";
import { baseUri } from "../config/config";

axios.defaults.headers.post["Content-Type"] = "application/json";

const DEV_LOGS = process.env.NODE_ENV === "development";

const joinApiUrl = (base, path) => {
  const root = String(base || "").replace(/\/+$/, "");
  const route = String(path || "").replace(/^\/+/, "");
  return `${root}/${route}`;
};

export async function invokeApi({
  path,
  method = "GET",
  headers = {},
  queryParams = {},
  postData = {},
}) {
  const reqObj = {
    method,
    url: joinApiUrl(baseUri, path),
    headers,
  };

  reqObj.params = queryParams;

  if (method === "POST") {
    reqObj.data = postData;
  }
  if (method === "PUT") {
    reqObj.data = postData;
  }
  if (method === "DELETE") {
    reqObj.data = postData;
  }

  let results;
  // Request logs only while developing, and never values: login passwords, the auth token header
  // and members' data used to be printed to every browser's console, live site included (rule 18).
  if (DEV_LOGS) {
    const fields = postData instanceof FormData ? [...postData.keys()] : Object.keys(postData || {});
    console.info("<===REQUEST===>", method, reqObj.url, fields);
  }

  try {
    results = await axios(reqObj);
    if (DEV_LOGS) console.info("<===Api-Success===>", method, reqObj.url, results.status);

    return results.data;
  } catch (error) {
    if (DEV_LOGS) {
      console.info("<===Api-Error===>", method, reqObj.url, error.response?.status || error.message);
    }

    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.reload();
    }
    return {
      code: error.response?.status || 500,
      message: error.response?.data?.message
        ? error.response.data.message
        : error.message || "",
      ...(error.response?.data?.errors
        ? { errors: error.response.data.errors }
        : {}),
      // Password-protected journeys: keep the gate flag + list-level tracker.
      ...(error.response?.data?.requirePassword
        ? {
            requirePassword: true,
            ...(error.response.data.tracker
              ? { tracker: error.response.data.tracker }
              : {}),
          }
        : {}),
    };
  }
}
